import { getFileInfo } from 'owa-fileprovider-link-services';
import AttachmentDataProviderType from 'owa-service/lib/contract/AttachmentDataProviderType';
import { GetODCSharingInfoResponse } from 'owa-fileprovider-link-services';
import { trace } from 'owa-trace';

export async function getSharingInformationForODCLinks(
    attachmentUrl: string
): Promise<GetODCSharingInfoResponse> {
    const result: string = await getFileInfo(
        attachmentUrl,
        AttachmentDataProviderType.OneDriveConsumer
    );
    trace.info(result);
    // VSTO: 57638 will return the right value for ODC links
    return null;
}
